import { render, staticRenderFns } from "./RoomDecorationRecord.vue?vue&type=template&id=42559f1e"
import script from "./RoomDecorationRecord.vue?vue&type=script&lang=js"
export * from "./RoomDecorationRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports